module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Reinach_AG-d8f424ed82418676e307c2c6d3e10943.svg";